import store from '@/packages/vuex'
import { Middleware } from '@/app/router'

export default new Middleware('Guest', ({ next, router }) => {
	if (store.getters['Auth/authenticated']) {
		router.push({
			name: 'Dashboard:Home'
		})
	} else {
		return next()
	}
})
